module.exports = __webpack_public_path__ + "static/media/ic_engins.753db287.svg";